import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

const initialState = {
  studentData: [],
  studentActiveTab: true,
  activityDetailsTab: {
    timeLine: true,
    course: false,
    podcast: false,
    challenges: false,
    liveStream: false,
  },
};
export const getStudent = createAsyncThunk(
  "student/getList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/userList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
export const studentStatus = createAsyncThunk(
  "student/status",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch("/userStatusChanged", payload);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
export const newUserStatus = createAsyncThunk(
  "student/newUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/markUserAsSeen", payload);
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
const studentSlice = createSlice({
  name: "student",
  initialState: initialState,
  extraReducers: (builder) => {
    builder.addCase(getStudent.fulfilled, (state, action) => {
      state.loader = false;
      state.studentData = action.payload;
    });
  },
  reducers: {
    changeActiveTab: (state, action) => {
      state.studentActiveTab = action.payload;
    },
    changeActivityDetailsTab: (state, action) => {
      state.activityDetailsTab = action.payload;
    },
  },
});
export const { changeActiveTab, changeActivityDetailsTab } =
  studentSlice.actions;
export default studentSlice.reducer;
